'use strict'

export default {
  ednRequired  : 'Merci de remplir ce champ',
  invalidMsg : {
    email : 'Vous devez entrer une adresse mail valide.',
    phone : 'Vous devez entrer un numéro de téléphone valide.',
    url : 'Vous devez entrer une url valide.',
    switch : 'Merci de bien vouloir activer le switch',
    image:'Url renseignée invalide',
    arbo:'Vous devez entrer au moins une valeur',
    num:'Vous devez entrer au moins une valeur numérique',
    field:'Valeur incorrecte'
  },
  image:{
    fileMsg:'Select a file from the disk',
    imgMsg:'Copy an URL'
  },
  /*eslint no-useless-escape: "error"*/
  maxSize:'la taille de l\'image ne doit pas excéder [SIZE] Mo' ,
  /*eslint no-useless-escape: "error"*/
  validateRes:'Valider',
  pasteContentRes: 'Url copiée',
  placeHolder : {
    ednUrl : 'http://',
    ednCopyPaste : '<script src="https:// >'
  },
  closeText:"Close"
}
